<section class="section mt-60" *ngIf="!thanksPage" style="background-color: #FFFFFF;">
  <div class="container">
    <div class="row align-items-center">
      <h4 class="mb-3">Register Agent</h4>
      <form>
        <div class="col-md-12 mb-3">
          <div class="card shadow rounded border-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <h6 class="card-title">Company Information</h6>
                </div>
                <div class="col-md-12 mb-3">
                  <label class="form-label">Business Name <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" id="floatingInput" placeholder="Business Name">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Business Phone <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" id="floatingInput" placeholder="Business Phone">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Base Currency <span class="text-danger">*</span></label>
                  <ngx-select [allowClear]="true" [items]="currenciesData" optionValueField="optionId"
                    optionTextField="optionTitle" placeholder="Select Base Currency">
                  </ngx-select>
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">Country <span class="text-danger">*</span></label>
                  <ngx-select [items]="countriesData" (selectionChanges)="changeCountry($event)"
                    [showOptionNotFoundForEmptyItems]='true' optionValueField="optionId" optionTextField="optionTitle"
                    placeholder="Select Country">
                  </ngx-select>
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">Province <span class="text-danger">*</span></label>
                  <ngx-select [items]="provinceData" (selectionChanges)="changeProvince($event)"
                    [showOptionNotFoundForEmptyItems]='true' optionValueField="optionId" optionTextField="optionTitle"
                    placeholder="Select Province"> </ngx-select>
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">City <span class="text-danger">*</span></label>
                  <ngx-select [items]="cityData" [showOptionNotFoundForEmptyItems]='true' optionValueField="optionId"
                    optionTextField="optionTitle" placeholder="Select City"> </ngx-select>
                </div>
                <div class="col-md-12 mb-3">
                  <label class="form-label">Business Address <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" id="floatingInput" placeholder="Business Address">
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">Postal Code <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" id="floatingInput" placeholder="Postal Code">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 mb-3">
          <div class="card shadow rounded border-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <h6 class="card-title">User Data</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<section class="bg-home bg-light d-flex align-items-center" *ngIf="thanksPage">
  <div class="container mt-100 mt-60">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-5 col-12">
        <img src="assets/images/illustrator/envelope.svg" class="img-fluid mx-auto d-block" alt="">
      </div>

      <div class="col-lg-7 col-md-7 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div class="section-title">
          <h4 class="title mb-4">Thank you <br> for register your account.</h4>
          <p class="text-muted para-desc mb-0">Please check your email to verify your account.</p>
          <div class="my-4">
            <a (click)="navigated('/')" class="btn btn-brand m-1"><i class='bx bx-left-arrow-alt'></i>Back to
              Home</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
